import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PageTitleUpdater = () => {
  const location = useLocation();

  useEffect(() => {
    const getPageTitle = (pathname: string): string | null => {
      // Remove trailing slash for consistent matching
      const path = pathname.replace(/\/$/, "");

      // Route-to-title mapping
      const titleMap: { [key: string]: string } = {
        "/": "Home | ClaryNext",
        "/portal": "Dashboard | ClaryNext",
        "/design": "Design Activity | ClaryNext",
        "/login": "Login | ClaryNext",
        "/register": "Sign Up | ClaryNext",
        "/forgotpassword": "Forgot Password | ClaryNext",
        "/resetpassword": "Reset Password | ClaryNext",
        "/profile": "Profile | ClaryNext",
        "/marketplace": "Library | ClaryNext",
        "/examples": "Examples | ClaryNext",
        "/cart": "Shopping Cart | ClaryNext",
        "/checkout": "Checkout | ClaryNext",
        "/orders": "My Orders | ClaryNext",
        "/admin": "Admin Panel | ClaryNext",
        "/users": "User Management | ClaryNext",
        "/terms": "Terms of Service | ClaryNext",
        "/privacy": "Privacy Policy | ClaryNext",
        "/about": "About | ClaryNext",
        "/contact": "Contact | ClaryNext",
        "/help": "Help | ClaryNext",
        "/settings": "Settings | ClaryNext",
      };

      // Check for exact match first
      if (titleMap[path]) {
        return titleMap[path];
      }

      // Handle dynamic routes
      // Note: /activities/run and /marketplace/product/* set their own titles dynamically
      // They also send their own GA4 page_view events, so we skip setting titles here
      if (path.startsWith("/activities/run")) {
        // Skip - component will set title and send GA4 event with actual activity name
        return null;
      }
      if (path.startsWith("/marketplace/product/")) {
        // Skip - component will set title and send GA4 event with actual product name
        return null;
      }
      if (path.startsWith("/activities/preview")) {
        return "Activity Preview | ClaryNext";
      }
      if (path.startsWith("/activities")) {
        return "Activities | ClaryNext";
      }
      if (path.startsWith("/marketplace/vendor/")) {
        return "Vendor Profile | ClaryNext";
      }
      if (path.startsWith("/marketplace")) {
        return "Marketplace | ClaryNext";
      }
      if (path.startsWith("/accept/")) {
        return "Accept Invitation | ClaryNext";
      }
      if (path.startsWith("/mentor")) {
        return "Mentor Session | ClaryNext";
      }
      if (path.startsWith("/admin")) {
        return "Admin Panel | ClaryNext";
      }

      // Default fallback
      return "ClaryNext";
    };

    // Update document title
    const newTitle = getPageTitle(location.pathname);
    if (newTitle) {
      document.title = newTitle;
    }
  }, [location.pathname]);

  // This component doesn't render anything
  return null;
};

export default PageTitleUpdater;
